import './index.less';

import React, { useEffect, useState } from 'react';
import { CompactPicker } from 'react-color';

interface ColorSelectTypes {
  value: string | undefined;
  onChange: (file: string | undefined) => any;
  defaultColors?: string[];
  disabled?: boolean;
}

export const ColorSelect: React.FC<ColorSelectTypes> = (props) => {
  const {
    defaultColors = [
      '#ffffff', // 白色
      '#ff6022', // 橙色
      '#ff1964', // 红色
      '#ff414e',
      '#fda742',
      '#568eff', // 蓝色
      '#cd87ff', // 紫色
      '#ff53fd',
      '#ff89ae', // 粉色
      '#ffd500', // 黄色
      '#fbf076',
      '#000000', // 黑色
      '#15de8f', // 绿色
      '#44eb1f', // 青色
      '#66e36a', // 黄绿色
      '#5B6B48',
      '#CE512B',
      '#232225',
      '#2E2F3F',
      '#54096A',
      '#3A7289',
      '#757650',
      '#85574E',
      '#643cf9',
    ],
  } = props;

  const [color, setColor] = useState<string>(props.value || '');

  const handleChangeComplete = (entColor: any) => {
    const tmpColor = entColor.hex === color ? '' : entColor.hex;
    setColor(tmpColor);
    props.onChange(tmpColor);
  };

  useEffect(() => {
    setColor(props.value || '');
  }, [props.value]);

  return (
		<>
			<div className={'colorPreview'} style={{ backgroundColor: color }}></div>
			{props.disabled ? null : (
				<CompactPicker color={color} colors={defaultColors} onChangeComplete={handleChangeComplete} />
			)}
		</>
  );
};
